<template>
     <div class="formulario-contacto obras">
            <mapa></mapa>
         <div class="container">
             <h2 class="text-center">Consultas</h2>

            <form id="my_form" v-if="formulario_activo" @submit.prevent="handleSubmit" enctype="multipart/form-data" >
            <div class="form-row">
                <div class="form-group col-sm-12 col-md-6">
                <label for="inputEmail4">NOMBRE Y APELLIDO:</label>
                <input type="text" class="form-control" id="name" placeholder="Nombre y Apellido" required v-model="name">
                </div>
                <div class="form-group  mt-md-0 col-sm-12 col-md-6">
                <label for="inputEmail4">Email:</label>
                <input id="email" class="form-control" placeholder="Email" type="email" required v-model="email">
                </div>

            </div>

            <div class="form-row">
                <div class="form-group col-sm-12 col-md-6">
                    <label for="inputEmail4">TELEFONO:</label>
                    <input type="text" class="form-control" id="subject" placeholder="Telefono" required v-model="phone">
                </div>

                <div class="form-group  col-sm-12 col-md-12">
                <label for="inputEmail4">Su Consulta:</label>
                    <textarea id="message" required v-model="message" class="form-control" rows="3"></textarea>
                </div>
            </div>
           <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6Lfnj2kUAAAAAENt6qI6L7PYXK9Sb9QBudvKYFwc"></vue-recaptcha>

            <button type="submit" class="btn btn-primary form-group mt-2" :disabled="boton_submit == false">Enviar</button>
            </form>

            <div class="gracias" v-else>Gracias!! Estaremos en contacto.</div>
        </div>
    </div>

</template>
     <script>
       import Mapa from './Datos_mapa.vue';
     import VueRecaptcha from 'vue-recaptcha';
     import axios from 'axios';
      export default {
        components: { VueRecaptcha, mapa:Mapa },
        data(){
          return{
            formulario_activo:true,
            name:'',
            email:'',
            phone:'',
            subject:'',
            message:'',
            response:'',
            boton_submit:false
          }
        },
        methods:{
          onVerify: function (response) {
            this.response = response;
            this.boton_submit = true;
          },
          handleSubmit(){
            var that = this;
            let formdata = new FormData();
            formdata.append( "template-contactform-name", this.name );
            formdata.append( "template-contactform-email", this.email );
            formdata.append( "template-contactform-phone", this.phone );
            formdata.append( "template-contactform-subject", `Formulario web de: ${this.name}`);
            formdata.append( "template-contactform-message", this.message );
            formdata.append( "g-recaptcha-response", this.response );
            formdata.append( "template-contactform-submit", "submit" );

           axios.post( '/pform/include/mensaje.php',
                formdata,
                {
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
                }
              ).then(function(){
                that.formulario_activo = false;
                console.log('SUCCESS!!');
              })
              .catch(error => {
                console.log(error)
              });


          }
        }
      }

          </script>

<style>
  .gracias{
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/contacto/Mensaje.vue